module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"action":{"toggle":"Přepnout navigaci"}},"de":{"action":{"toggle":"Navigation umschalten"}},"es":{"action":{"toggle":"Alternar la navegación"}},"fr":{"action":{"toggle":"Basculer la navigation"}},"id":{"action":{"toggle":"Navigasi Toggle"}},"ja":{"action":{"toggle":"ナビゲーションを有効化"}}}')
  delete Component.options._Ctor
}
